<div class="breadcrumb">
  <div class="container">
    Home
  </div>
</div>

<div class="container dashboard">
  <h1>{{ 'Dashboard' | translate }}</h1>

  <mat-tab-group animationDuration="150ms" class="dashboard-tabs">

    <!-- ══════════════════ ABA GRÁFICOS ══════════════════ -->
    <mat-tab label="{{ 'Gráficos' | translate }}" *ngIf="false">

      <!-- Filtros -->
      <div class="filtros-bar">
        <div class="filtro">
          <label for="cboAno">{{ 'Ano' | translate }}</label>
          <select id="cboAno" [(ngModel)]="filtro.ano" (change)="atualizaFiltro()">
            <option *ngFor="let a of listAnos" [value]="a">{{ a }}</option>
          </select>
        </div>

        <div class="filtro">
          <label for="cboPais">{{ 'País' | translate }}</label>
          <select id="cboPais" [(ngModel)]="filtro.pais" (change)="atualizaFiltro()">
            <option value="">{{ 'Todos' | translate }}</option>
            <option *ngFor="let p of listPaises" [value]="p">{{ p }}</option>
          </select>
        </div>

        <div class="filtro">
          <label for="cboMes">{{ 'Mês' | translate }}</label>
          <select id="cboMes" [(ngModel)]="filtro.mes" (change)="atualizaFiltro()">
            <option value="">{{ 'Todos' | translate }}</option>
            <option *ngFor="let m of listMeses" [value]="m">{{ m }}</option>
          </select>
        </div>

        <div class="filtro">
          <label for="cboProvedor">{{ 'Provedor' | translate }}</label>
          <select id="cboProvedor" [(ngModel)]="filtro.provedor" (change)="atualizaFiltro()">
            <option value="">{{ 'Todos' | translate }}</option>
            <option *ngFor="let pv of listProvedores" [value]="pv">{{ pv }}</option>
          </select>
        </div>

        <button class="clear-button" (click)="clearFiltros()">{{ 'Limpar Filtros' | translate }}</button>
      </div>

      <!-- Gráficos -->
      <div class="charts-row">

        <!-- ── Chart Prescrições ─────────────────────────────────────── -->
        <div class="chart-card">

          <div class="card-nav" *ngIf="isDrilledPrescricoes">
            <button class="back-button" (click)="voltarPrescricoes()">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" stroke-width="2.5"
                   stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
              {{ 'Voltar' | translate }}
            </button>
            <span class="nav-breadcrumb">
              {{ 'Prescrições' | translate }} › {{ paisPrescricoes }}
            </span>
          </div>

          <h2>
            <span *ngIf="!isDrilledPrescricoes">{{ 'Prescrições por País' | translate }}</span>
            <span *ngIf="isDrilledPrescricoes">
              {{ 'Prescrições por Mês' | translate }}
              <span class="chart-subtitle"> — {{ paisPrescricoes }}</span>
            </span>
            <span class="click-hint" *ngIf="!isDrilledPrescricoes">
              {{ '↓ clique para detalhar' | translate }}
            </span>
          </h2>

          <div class="chart-loading" *ngIf="isLoadingPrescricoes">
            <div class="chart-spinner"></div>
          </div>
          <ng-container *ngIf="!isLoadingPrescricoes">
            <div class="chart-container" *ngIf="!semDadosPrescricoes; else semDadosTpl1">
              <canvas baseChart
                [data]="prescricoesChartData"
                [options]="prescricoesChartOptions"
                type="bar"
                (chartClick)="onPrescricoesClick($event)">
              </canvas>
            </div>
            <ng-template #semDadosTpl1>
              <div class="sem-dados">{{ 'Nenhum dado encontrado' | translate }}</div>
            </ng-template>
          </ng-container>
        </div>

        <!-- ── Chart Revisadas ──────────────────────────────────────── -->
        <div class="chart-card" [class.chart-card--clickable]="isDrilledRevisadas && !isDrilledRevisor">

          <div class="card-nav" *ngIf="isDrilledRevisadas">
            <button class="back-button" (click)="isDrilledRevisor ? voltarRevisor() : voltarRevisadas()">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" stroke-width="2.5"
                   stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
              {{ 'Voltar' | translate }}
            </button>
            <span class="nav-breadcrumb">
              <ng-container *ngIf="!isDrilledRevisor">
                {{ 'Revisadas' | translate }} › {{ paisRevisadas }}
              </ng-container>
              <ng-container *ngIf="isDrilledRevisor">
                {{ 'Revisadas' | translate }} › {{ paisRevisadas }} › {{ 'Mês' | translate }} {{ mesRevisadas }}
              </ng-container>
            </span>
            <button class="back-button back-button--sm" *ngIf="isDrilledRevisor" (click)="voltarRevisadas()">
              {{ 'Início' | translate }}
            </button>
          </div>

          <h2>
            <span *ngIf="!isDrilledRevisadas">{{ 'Prescrições Revisadas por País' | translate }}</span>
            <span *ngIf="isDrilledRevisadas && !isDrilledRevisor">
              {{ 'Revisadas por Mês' | translate }}
              <span class="chart-subtitle"> — {{ paisRevisadas }}</span>
              <span class="click-hint">{{ '↓ clique para detalhar' | translate }}</span>
            </span>
            <span *ngIf="isDrilledRevisor">
              {{ 'Revisadas por Revisor' | translate }}
              <span class="chart-subtitle"> — {{ paisRevisadas }} / {{ 'Mês' | translate }} {{ mesRevisadas }}</span>
            </span>
          </h2>

          <div class="chart-loading" *ngIf="isLoadingRevisadas">
            <div class="chart-spinner"></div>
          </div>
          <ng-container *ngIf="!isLoadingRevisadas">
            <div class="chart-container" *ngIf="!semDadosRevisadas; else semDadosTpl2">
              <canvas baseChart
                [data]="revisadasChartData"
                [options]="revisadasChartOptions"
                type="bar"
                (chartClick)="onRevisadasClick($event)">
              </canvas>
            </div>
            <ng-template #semDadosTpl2>
              <div class="sem-dados">{{ 'Nenhum dado encontrado' | translate }}</div>
            </ng-template>
          </ng-container>
        </div>

      </div>
    </mat-tab>

    <!-- ══════════════════ ABA QUADRO CONSOLIDADO ══════════════════ -->
    <mat-tab label="{{ 'Quadro Consolidado' | translate }}">
      <app-resumo-batch-mes></app-resumo-batch-mes>
    </mat-tab>

    <!-- ══════════════════ ABA ABIERTO POR PDV ══════════════════ -->
    <mat-tab label="{{ 'Abierto por PDV' | translate }}">
      <app-resumo-batch-pdv></app-resumo-batch-pdv>
    </mat-tab>

  </mat-tab-group>
</div>
